/**
 * Configuration for Salt Lake City Weekly JOBS frontend.
 */
const jobiqoAppConfig = require('../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];
const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'Salt Lake City Weekly JOBS',
    SITE_DESCRIPTION: 'Salt Lake City Weekly JOBS - Your career destination.',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    ASSETS: {
      logo: '/static/slc/logo.jpg',
      faviconsPath: '/static/slc',
    },
    OG_IMAGE: '/static/slc/logo.jpg',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#5B7A91',
        secondary: '#FFD522',
      },
    },
    PRICE_CONFIG: priceConfig,
    BLOG_FEATURE_ACTIVE: true,
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: true,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    SOCIAL_LINKS: {
      facebook: 'https://www.facebook.com/slcweekly',
      instagram: 'https://www.instagram.com/slcweekly',
      twitter: 'https://x.com/cityweekly',
      linkedin: 'https://www.linkedin.com/company/salt-lake-city-weekly',
    },
    GA4_MEASUREMENT_IDS: ['G-04SBN34ERZ'],
  },
});
